import React from 'react';

import SupplierPortalSettingsFieldCreateForm from './SupplierPortalSettingsFieldCreateForm';

import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

const SupplierPortalSettingsFieldEditModal = (props) => {
    const internalCloseHandler = () => {
        props.closeHandler();
    };

    const internalSuccessHandler = () => {
        props.successHandler();
    };

    const close = () => {
        internalCloseHandler();
    };

    return (
        <Modal modal={props.modal}>
            <ModalHeader close={close}>{$t('Edit Field')}</ModalHeader>
            <div>
                {Object.keys(props.field).length > 0 && (
                    <div className="modal__form-container">
                        <SupplierPortalSettingsFieldCreateForm
                            types={props.types}
                            states={props.states}
                            request={props.request}
                            saveUrl={props.saveUrl.replace('FIELD_ID', props.field.id)}
                            internalCloseHandler={internalCloseHandler}
                            internalSuccessHandler={internalSuccessHandler}
                            fetchData={props.fetchData}
                            field={props.field}
                            close={close}
                        />
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default React.memo(SupplierPortalSettingsFieldEditModal);
